import { DrawerProps as MuiDrawerProps } from '@mui/material/Drawer'

export type DrawerProps = MuiDrawerProps
